/* web/app/components/rfq/rfq-modal/rfq-modal.scss */
.btn-hover-effect button {
  border: 1px solid #999999 !important;
  color: #10688f !important;
  background: #ccc !important;
}
.modal-header div {
  font-size: 1.5rem;
  font-weight: 600;
}
@media (max-width: 768px) {
  ::ng-deep .rfq-dialog.cdk-overlay-pane {
    width: 80% !important;
    max-height: 80%;
    overflow-y: auto;
  }
}
.rfq-modal {
  padding: 2rem;
  max-height: 70vh;
  overflow: overlay;
}
.modal-body > div {
  font-weight: 700;
}
.modal-body .form-group .form-control-label {
  font-weight: 700;
}
.modal-body .form-group .form-control {
  border: 1px solid #4abcec;
  border-radius: 30px;
  height: auto;
  padding: 13px;
}
.mat-dialog-container {
  border-radius: 50px;
}
::ng-deep .mat-dialog-container {
  border-radius: 20px;
  padding: 0;
}
::ng-deep .mat-dialog-container .modal-header {
  border-radius: 20px 20px 0 0;
}
::ng-deep .mat-dialog-container .modal-header button.close {
  opacity: 1;
}
/*# sourceMappingURL=rfq-modal.css.map */
